import React, { useState } from 'react';
import { WeaponCourseProgramStyles } from './WeaponCourseProgramStyles';
import { TextWithDot } from '../textWithDot/TextWithDot';
import Modal from '../modal/Modal';
import ContactForm from '../contactForm/ContactForm';
import { InView } from 'react-intersection-observer';
import getTranslationByLangOrUk from '../../utils/getTranslationByLangOrUk';
import { useAppSelector } from '../../state/hooks';

interface Props {
  subtitle?: string,
  lists: {
    title: string,
    subtitle?: string,
    program: string[],
    costList: string[],
    sublist?: string[],
  }[],
}

// const data: Props = {
//   subtitle: '(3 персональні методичні заняття)',
//   lists: [
//     {
//       title: '',
//       program: [
//         '',
//         '',
//         '',
//         '',
//         '',
//         '',
//         '',
//       ],
//       description: [
//         '',
//         '',
//         '',
//       ],
//       sublist: [
//         '',
//       ],
//     },
// };

function WeaponCourseProgram({ data }: {data: Props}) {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [formActiveIndex, setFormActiveIndex] = useState<number>(0);

  const { interfaceLanguage } = useAppSelector((state) => state.languages);

  return (
    <WeaponCourseProgramStyles>
      {modalOpen && (
        <Modal onClose={() => setModalOpen(false)}>
          <ContactForm
            withoutTitle
            inModal
            emailDescription={data.lists[formActiveIndex].title}
          />
        </Modal>
      )}

      <div className="container">
        <InView className="headWrapper" threshold={1} onChange={(inView, entry) => (inView ? entry.target.classList.add('active') : '')}>
          <h2>{getTranslationByLangOrUk(interfaceLanguage, 'course_program')}</h2>
          <p className="subtitle">{data.subtitle}</p>
        </InView>

        <div className="listsWrapper">
          {data.lists.map((listData, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <InView key={index} className="listAnimationItem" threshold={0.25} onChange={(inView, entry) => (inView ? entry.target.classList.add('active') : '')}>
              <div className="listWrapper">
                <div className="titleWrapper">
                  {listData.title && <h3>{listData.title}</h3>}
                  {listData.subtitle && <p className="textBase18">{listData.title}</p>}
                </div>

                <ul>
                  {listData.program.map((text) => <li className="textBase18" key={text}><TextWithDot text={text} /></li>)}
                </ul>
              </div>

              {listData.costList && (
                <div className="costWrapper">
                  {listData.costList.map((text) => <p key={text} className="textBase18">{text}</p>)}
                </div>
              )}

              {listData.sublist && (
                <ul className="sublist">
                  {listData.sublist.map((text) => <li key={text} className="textBase18"><TextWithDot text={text} /></li>)}
                </ul>
              )}

              {/* eslint-disable-next-line react/button-has-type */}
              <button
                className="button"
                onClick={() => {
                  setModalOpen(true);
                  setFormActiveIndex(index);
                }}
              >
                {getTranslationByLangOrUk(interfaceLanguage, 'gift_sertificates_8')}
              </button>

            </InView>
          ))}
        </div>
      </div>
    </WeaponCourseProgramStyles>
  );
}

export default WeaponCourseProgram;
